/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: nCl4kJqd_uCB

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFeaturesProductHeader.module.css"; // plasmic-import: nCl4kJqd_uCB/css

createPlasmicElementProxy;

export type PlasmicFeaturesProductHeader__VariantMembers = {};
export type PlasmicFeaturesProductHeader__VariantsArgs = {};
type VariantPropType = keyof PlasmicFeaturesProductHeader__VariantsArgs;
export const PlasmicFeaturesProductHeader__VariantProps =
  new Array<VariantPropType>();

export type PlasmicFeaturesProductHeader__ArgsType = {
  children?: React.ReactNode;
  subtitle?: string;
  description?: string;
};
type ArgPropType = keyof PlasmicFeaturesProductHeader__ArgsType;
export const PlasmicFeaturesProductHeader__ArgProps = new Array<ArgPropType>(
  "children",
  "subtitle",
  "description"
);

export type PlasmicFeaturesProductHeader__OverridesType = {
  col?: Flex__<"div">;
  subtitleText?: Flex__<"h3">;
  descriptionText?: Flex__<"p">;
};

export interface DefaultFeaturesProductHeaderProps {
  children?: React.ReactNode;
  subtitle?: string;
  description?: string;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeaturesProductHeader__RenderFunc(props: {
  variants: PlasmicFeaturesProductHeader__VariantsArgs;
  args: PlasmicFeaturesProductHeader__ArgsType;
  overrides: PlasmicFeaturesProductHeader__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"col"}
      data-plasmic-override={overrides.col}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.col
      )}
    >
      <h3
        data-plasmic-name={"subtitleText"}
        data-plasmic-override={overrides.subtitleText}
        className={classNames(
          projectcss.all,
          projectcss.h3,
          projectcss.__wab_text,
          sty.subtitleText
        )}
      >
        {hasVariant(globalVariants, "mobile", "mobile") ? (
          <React.Fragment>{$props.subtitle}</React.Fragment>
        ) : (
          <React.Fragment>{$props.subtitle}</React.Fragment>
        )}
      </h3>
      {renderPlasmicSlot({
        defaultContents: (
          <Logo
            className={classNames("__wab_instance", sty.logo__lVytp)}
            product={"myEvaluations"}
          />
        ),

        value: args.children
      })}
      <p
        data-plasmic-name={"descriptionText"}
        data-plasmic-override={overrides.descriptionText}
        className={classNames(
          projectcss.all,
          projectcss.p,
          projectcss.__wab_text,
          sty.descriptionText
        )}
      >
        {hasVariant(globalVariants, "mobile", "mobile") ? (
          <React.Fragment>{$props.description}</React.Fragment>
        ) : (
          <React.Fragment>{$props.description}</React.Fragment>
        )}
      </p>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  col: ["col", "subtitleText", "descriptionText"],
  subtitleText: ["subtitleText"],
  descriptionText: ["descriptionText"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  col: "div";
  subtitleText: "h3";
  descriptionText: "p";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeaturesProductHeader__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeaturesProductHeader__VariantsArgs;
    args?: PlasmicFeaturesProductHeader__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicFeaturesProductHeader__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicFeaturesProductHeader__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeaturesProductHeader__ArgProps,
          internalVariantPropNames: PlasmicFeaturesProductHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeaturesProductHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "col") {
    func.displayName = "PlasmicFeaturesProductHeader";
  } else {
    func.displayName = `PlasmicFeaturesProductHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicFeaturesProductHeader = Object.assign(
  // Top-level PlasmicFeaturesProductHeader renders the root element
  makeNodeComponent("col"),
  {
    // Helper components rendering sub-elements
    subtitleText: makeNodeComponent("subtitleText"),
    descriptionText: makeNodeComponent("descriptionText"),

    // Metadata about props expected for PlasmicFeaturesProductHeader
    internalVariantProps: PlasmicFeaturesProductHeader__VariantProps,
    internalArgProps: PlasmicFeaturesProductHeader__ArgProps
  }
);

export default PlasmicFeaturesProductHeader;
/* prettier-ignore-end */
